import { apiEndpoints } from "core/api/apiEndpoints";
import { httpRequest } from "core/api/httpRequest";

// get symptom data
const getSymptomData = (payload: any) => {
  return httpRequest(apiEndpoints.symptomData, "post", payload);
};

// save period data
const savePeriodData = (payload: any) => {
  return httpRequest(apiEndpoints.savePeriodData, "post", payload);
};

//save symptom data
const saveSymptomData = (payload: any) => {
  return httpRequest(apiEndpoints.saveSymptom, "post", payload);
};
export { getSymptomData, savePeriodData, saveSymptomData };
